import styled from "styled-components"

export const Table = styled.table`
  position: relative;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: .5em;
  text-align: center;
  margin: 0 auto;
  z-index: 1;
  width: 95%;
`

export const TableContainer = styled.div`
  overflow:auto;
  max-height: 60vh;
  margin:auto;
  margin-top: 1.25em;

  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.trackColor};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.thumbColor};
  }

  ::-webkit-scrollbar-corner{
    background-color: ${({ theme }) => theme.colors.trackColor};
  }

  @media screen and (max-width:768px){
    width: 98%;
  }
`

export const TableBody = styled.tbody`  

`

export const TableRow = styled.tr`
  
`

export const TableHead = styled.th`
  vertical-align: middle;
  position: sticky;
  top: -1px;
  text-align: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.tableText};
  font-size: 2em;
  padding: .5em .5em;
  font-weight: bold;
  border: 1px solid ${({ theme }) => theme.colors.tableBorder};
  background-color: ${({ theme }) => theme.colors.tableHead};

  &.defaultCursor{
    cursor:default;
  }

  @media screen and (max-width:768px){
    font-size: 1em;
  }
`

export const TableCell = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.tableBorder};
  color: ${({ theme }) => theme.colors.tableText};
  font-size: 2em;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.tableCell};
  text-align: center;
  padding: .5em;
  cursor: pointer;
  font-weight:bold;
  &.mild{
    color:${({ theme }) => theme.colors.mild};
  }

  &.moderate{
    color: ${({ theme }) => theme.colors.moderate};
  }

  &.high{
    color: ${({ theme }) => theme.colors.high};
  }

  &.urgent{
    color: ${({ theme }) => theme.colors.urgent};
  }

  @media screen and (max-width:768px){
        font-size: 1.5em;
  }
  
  @media screen and (max-width:380px){
        font-size: 1em;
  }
`

export const FormText = styled.span`
    &.done{
        color:${({ theme }) => theme.colors.mild};
    }

    &.incomplete{
        color: ${({ theme }) => theme.colors.urgent};
    }
`

export const LegendBox = styled.div`
  width: 20px;
  height: 20px;

  &.done{
    background-color: ${({ theme }) => theme.colors.mild};
  }

  &.incomplete{
    background-color: ${({ theme }) => theme.colors.urgent};
  }

  @media screen and (max-width:768px){
    width: 15px;
    height: 15px;
  }

  @media screen and (max-width:380px){
    width: 10px;
    height: 10px;
  }
`

export const LegendText = styled.div`
  font-size: 1em;
  color: ${({ theme }) => theme.colors.textColor};
  text-align: center;
  padding: .5em;

  @media screen and (max-width:768px){
    font-size: .75em;
  }

  @media screen and (max-width:440px){
    font-size: .65em;
  }
`